/* eslint-disable class-methods-use-this */
import Session, { CSRF_TOKEN_KEY } from '@getpopsure/session';
import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { AccountInfo } from 'components/IntercomLoaderWrapper/models/account.model';
import { IdentityHashResponse } from 'components/IntercomLoaderWrapper/models/intercom.model';
import initializeSession from 'shared/session';

const endpoint = process.env.NEXT_PUBLIC_FEATHER_API_URL;

if (!endpoint) {
  throw new Error("NEXT_PUBLIC_FEATHER_API_URL isn't set");
}

initializeSession();

export class Client {
  public network: AxiosInstance;

  constructor() {
    this.network = axios.create({
      baseURL: endpoint,
      timeout: 10000,
      xsrfCookieName: CSRF_TOKEN_KEY,
      xsrfHeaderName: 'csrf-token',
      withXSRFToken: true,
      withCredentials: true,
      headers: {
        'auth-version': 'v2',
      },
    });

    Session.addAxiosInterceptors(this.network);
  }

  // <--- Endpoints -->
  public getAccountInfo() {
    return this.network.get<AccountInfo>('/me');
  }

  public getIntercomVerificationHash(): Promise<
    AxiosResponse<IdentityHashResponse>
  > {
    return this.network.post('/me/intercom_identity_hash');
  }
}

const client = new Client();

export default client;
